module.exports = __webpack_public_path__ + "static/media/electronics2.c9876fee.jpg";